
const digest = '0f8203c467a34774b3597f34cce6642ef8a1185c3c6c650b439c7b44962ba23f';
const classes = {"wrapper":"_wrapper_ah2yc_1","priceTitle":"_priceTitle_ah2yc_6","promoCodeWrapper":"_promoCodeWrapper_ah2yc_10","input":"_input_ah2yc_16","button":"_button_ah2yc_19"};
const css = `._wrapper_ah2yc_1 {
  position: relative;
  background: #ffffff;
}

._priceTitle_ah2yc_6 {
  display: flex;
}

._promoCodeWrapper_ah2yc_10 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: flex-end;
}
._promoCodeWrapper_ah2yc_10 ._input_ah2yc_16 {
  flex: 1;
}
._promoCodeWrapper_ah2yc_10 ._button_ah2yc_19 {
  height: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  